





























































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import FileUpload from '@/components/FileUpload.vue';
import {ApiService, ApiV2Service} from '../services/api.base.service';
import OrganisationService from '../services/organisation.service';
import { getOrgImage } from '@/classes/images';
import { Cropper } from 'vue-advanced-cropper';
import '../classes/blob.image.convert';
import UserService from '@/services/user.service';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import OrganisationAdmin from '@/components/settings/OrganisationAdmin.vue';
import {CommercialAccount} from '@/types';

@Component({
  components: {
    GenericButton,
    ConfirmButton,
    CancelButton,
    Dialog,
    FileUpload,
    Cropper,
    OrganisationAdmin,
  },
})
export default class OrganisationEdit extends Vue {

  private get accountName() {
    return this.account.account && this.account.account.name ? this.account.account.name : 'Invalid name';
  }

  private get getLogoSrc(): string {
    let src = '';
    if (this.logo) {
      src = URL.createObjectURL(this.logo);
    }
    return src;
  }

  get accountList() {
    return this.accessibleAccounts.map((a) => ({
      name: `${a.name}${a.legal_entity_name && a.legal_entity_name !== a.name ? ` (${a.legal_entity_name})` : ''}`,
      id: a.id,
    }));
  }
  @Action private updateOrganisationAsync: any;
  @Action private createOrganisationAsync: any;
  @Action private addUsersAsync: any;
  @Getter private login: any;
  @Getter private getOrganisationById!: any;
  @Getter private users: any;
  @Getter private activeOrganisation: any;
  @Getter private hasPermission: any;
  @Prop() private organisation: any;
  @Prop() private showOrganisationDialog!: boolean;
  private organisationId: number | null = null;

  private needsBillingAccount: boolean = false;
  private logo: Blob | null = null;
  private croppedLogo: Blob | null = null;
  private isSaving: boolean = false;
  private saveImage: boolean = false;
  private showCropper: boolean = false;
  private accessibleAccounts: any[] = [];
  private account: any = null;

  public async save() {
    this.$emit('saving', true);
    let close = false;
    try {
      let response: any = null;
      if (this.organisation.id > 0) {
        response = await this.updateOrganisationAsync({
          id: Number(this.organisation.id),
          payload: {
            name: this.organisation.name,
            billing_account_id: this.organisation.billing_account_id,
          },
        });
      } else {
        response = await this.createOrganisationAsync({
          name: this.organisation.name,
          billing_account_id: this.organisation.billing_account_id,
        });
      }
      if (response) {
        if (this.saveImage) {
          if (this.croppedLogo || this.logo) {
            await OrganisationService.uploadOrganisationLogo(response.id, this.croppedLogo || (await this.logo!.toPNG()));
            if (this.croppedLogo) {
              this.showCropper = false;
              this.logo = this.croppedLogo;
              this.$forceUpdate();
            }
          } else {
            await OrganisationService.removeOrganisationLogo(response.id);
          }
        }
        close = true;
      }
    } finally {
      this.$emit('saving', false);
      this.logo = null;
      if (close) {
        this.$emit('close');
      }
    }
  }

  private mounted() {
    this.account = null;
    this.load();
  }

  private async load() {
    if (this.organisation.id) {
      this.account = await ApiService.get< CommercialAccount >(`organisation/${this.organisation.id}/billing`);
    }
    const apiJobs: Array<Promise<any>> = [];
    apiJobs.push(this.addUsersAsync({
      take: 0,
      skip: 0,
      sort: null,
      desc: null,
      filters: [],
      searchNames: null,
      projectId: null,
    }));
    const orgLogo = this.getOrgImage();
    if (orgLogo.length) {
      apiJobs.push(ApiV2Service.getBlobExt(orgLogo, { crossDomain: true }));
    }
    try {
      const results = await Promise.all(apiJobs);
      if (results.length === 2) {
        this.logo = results[1];
      }
    } catch (e) {
      // tslint:disable-next-line
      console.warn(e);
    }

    this.accessibleAccounts = await UserService.getAccounts();
    if (this.hasPermission('administration:manage')) {
      this.needsBillingAccount = true;
    } else {
      if (!this.organisation.billing_account_id) {
        if (!this.accessibleAccounts || this.accessibleAccounts.length === 0) {
          this.organisation.billing_account_id = this.activeOrganisation[0].billing_account_id;
        } else {
          this.needsBillingAccount = true;
        }
      }
    }
  }

  private selectOrganisation(organisation: any) {
    this.organisationId = organisation.value;
  }

  private async handleFileUpload(file: any): Promise<void> {
    this.saveImage = true;
    this.logo = file.files[0];
  }

  private removeLogo(): void {
    this.saveImage = true;
    this.logo = null;
  }

  private getOrgImage(): string {
    if (this.organisation && this.organisation.slug) {
      return getOrgImage(this.organisation);
    } else {
      return '';
    }
  }

  private async onCropperChange(event: any) {
    const canvas: HTMLCanvasElement = event.canvas;
    await (new Promise((res, reject) =>
        canvas.toBlob((blob: Blob | null) => {
          this.croppedLogo = blob;
        }, 'image/png'),
    ));
  }

  private getImageSize(event: any) {
    this.showCropper = event.target.height !== event.target.width;
    if (!this.showCropper) {
      event.target.style.visibility = 'visible';
    }
  }
}
